import { useEffect } from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import useToaster from '../../toaster/hooks/useToaster';

/**
 * Sends the user back to the list when the entity behind a deep link is gone, and says why.
 * `entityLabel` names the entity in that message ("Pipeline #902 not found"); without it the
 * redirect stays silent, which is how a page that shows its own message opts out.
 */
export function useRedirectOnResolveError({
  error,
  redirectPath,
  entityLabel,
  entityId
}: {
  error: any;
  redirectPath: string;
  entityLabel?: string;
  entityId?: number | string;
}) {
  const history = useHistory();
  const toaster = useToaster();

  useEffect(() => {
    if (!error) {
      return;
    }

    if (error.status === 404) {
      if (entityLabel) {
        const entityName = entityId === undefined || entityId === null ? entityLabel : `${entityLabel} #${entityId}`;
        toaster.pop('error', undefined, `${entityName} not found`);
      }

      history.replace(redirectPath);
    }
  }, [error]);
}
